// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-stats-row {\n  container-type: inline-size;\n}\n\n@container (max-width: 783.98px) {\n  .profile-stat-pair {\n    --stat-gap: 12px;\n  }\n}", ""]);
// Exports
module.exports = exports;
